// Get Workflw Data
export const GET_WORKFLOW_CHART_DATA = "GET_WORKFLOW_CHART_DATA";
export const GET_WORKFLOW_CHART_DATA_SUCCESS = "GET_WORKFLOW_CHART_DATA_SUCCESS";
export const GET_WORKFLOW_CHART_DATA_FAILURE = "GET_WORKFLOW_CHART_DATA_FAILURE";
export const GET_WORKFLOW_CHART_DATA_RESET = "GET_WORKFLOW_CHART_DATA_RESET";
